import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { TEST_CONFIG_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type { MonitorTestConfig } from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  id?: string
  children?: () => ReactElement
  onSuccess?: () => void
  onError?: () => void
  params: MonitorTestConfig
}

const PutPostTestConfigRequest = ({
  id,
  children,
  onSuccess,
  onError,
  params
}: Props) => {
  const url = id
    ? `${TEST_CONFIG_SERVICE}/test_configurations/${id}`
    : `${TEST_CONFIG_SERVICE}/test_configurations`

  const method = id
    ? 'put'
    : 'post'

  const { requestParams } = useGetParamsWithSpaceId<MonitorTestConfig|undefined>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method={method}
      onError={onError}
      onSuccess={onSuccess}
      params={
        id
          ? params
          : requestParams
      }
      url={url}
    />
  )
}

export default PutPostTestConfigRequest
